<div *ngIf="preview" style="text-align:center;font-style: bold;width:50%;margin-top:10px;margin-bottom:10px;margin-left:25%;padding:10px;background-color:#fbe6b7;" >
  <p>DEMO VERSION ONLY</p>
  <p>If you are not testing please use our <a href="https://simtools.edwardsvacuum.com/gasflow">latest release</a></p>
</div>
<div
  style="display: flex; width:100%;flex-wrap: wrap;margin-top:20px;margin-left: auto;margin-right: auto;justify-content: center;padding-bottom:20px">
  <div class="parameters-and-mixedresult">
    <div class="parameters">
      <parameters (editing)="isEditing=$event" (calculationResult)="addResult($event)" (parametersChange)="updateParameters($event)" [gas]="gas"></parameters>
    </div>
    <app-result-table *ngIf="mixedResults[0] && !rangedResult[0]"
      [solverResultsAndConditonsAndRangeVariable]="mixedResults"></app-result-table>
  </div>

  <div *ngIf="(!rangedResult[0] && mixedResults[0]) || isEditing " class="diagram">
    <app-diagram [pipes]="pipes" [result]="diagramResult" [title]="diagramTitle"></app-diagram>
  </div>
  <div class="ranged-result" *ngIf="rangedResult[0]">
    <app-ranged-result [solverResultsAndConditonsAndRangeVariable]="rangedResult"></app-ranged-result>
  </div>
</div>
